export function validateEmployeeId(employeeId: string | number): boolean {
	const parsedId =
		typeof employeeId === 'string'
			? Number.parseInt(employeeId, 10)
			: employeeId;
	if (!Number.isInteger(parsedId) || parsedId < 1) {
		console.error('Invalid data employeeId');
		return false;
	}
	return true;
}
